export default {
    ADD_SECTION: 'ADD_SECTION',
    EDIT_SECTION: 'EDIT_SECTION',
    DELETE_SECTION: 'DELETE_SECTION',
    UPDATE_FULL_SECTIONS: 'UPDATE_FULL_SECTIONS',
    UPDATE_REORDERED_SECTIONS: 'UPDATE_REORDERED_SECTIONS'
  };
  